import script from "./Banners.vue?vue&type=script&setup=true&lang=js"
export * from "./Banners.vue?vue&type=script&setup=true&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=49e44828&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e44828"]])

export default __exports__